export enum InterpreterResponseStatus {
  OPEN = 'OPEN',
  ACCEPTED = 'ACCEPTED',
  MODIFIED = 'MODIFIED',
  DECLINED = 'DECLINED',
  SELECTED = 'SELECTED'
}
